import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { APIProvider } from '@vis.gl/react-google-maps';
import SearchField from '../Map/SearchField';
import ClinicResults from './ClinicResults';
import ServiceFilter from './ServiceFilter';
import ClinicKey from '../Shared/ClinicKey';
import { useMapsLibrary } from '@vis.gl/react-google-maps';

const servicesData = {
    "travel": "Travel Services",
    "sh": "Sexual Health",
    "vaccinations": "Vaccinations",
    "blood-tests": "Blood Testing",
    "private-gp": "Private GP"
};

ClinicServices.propTypes = {
    config: PropTypes.object
};

export default function ClinicServices({
    config
}) {
    const [selectedAddress, setSelectedAddress] = useState({
        address: "",
        lat: 51.5048541,
        lng: -0.1136621
    });
    const [radius, setRadius] = useState(50);
    const [clinicData, setClinicData] = useState([]);
    const [service, setService] = useState(config.service ? config.service : null);
    const [loading, setLoading] = useState(true);
    const [filteredResults, setFilteredResults] = useState([]);
    const geometryLibrary = useMapsLibrary('geometry');

    const onSelectAddress = (updatedObj) => {
        setSelectedAddress(updatedObj);
    };

    const onServiceChange = (service) => {
        setService(service);
    };

    const onRadiusChange = (radius) => {
        setRadius(radius);
    };

    const getClinicData = async () => {
        let url = '/cd/feeds/finder/clinics';
        if (service) {
            url += '/' + service;
        }
        fetch(url)
            .then(response => response.json())
            .then(data => {
                setClinicData(data);
            })
            .catch(error => {
                console.error(error);
            });
    };

    function isPriorityClinic(clinic) {
        return clinic.flagship && clinic.title.includes('London') && clinic.distance <= 10;
    }

    useEffect(() => {
        if (!geometryLibrary || !clinicData.length) return;
        let reduced = clinicData.filter((clinic) => {
            if (!Object.keys(selectedAddress).length) return false;

            const clinicLocation = {
                lat: clinic.lat,
                lng: clinic.lng,
            };
            const selectedAddressLocation = {
                lat: selectedAddress.lat,
                lng: selectedAddress.lng,
            };

            const { spherical } = geometryLibrary;
            const distance = spherical.computeDistanceBetween(
                selectedAddressLocation,
                clinicLocation
            );
            const distanceInMiles = Math.ceil(distance * 0.000621371192);

            clinic.distance = distanceInMiles;

            return distanceInMiles < radius;
        });

        reduced.sort((a, b) => {
            if (isPriorityClinic(a)) {
                if (isPriorityClinic(b)) {
                    if (a.id == 7453) {
                        return -1;
                    } else if (b.id == 7453) {
                        return 1;
                    } else {
                        return a.distance - b.distance;
                    }
                }
                return -1;
            } else if (isPriorityClinic(b)) {
                return 1;
            }
            return a.distance - b.distance;
        });
        setLoading(false);
        setFilteredResults(reduced);
    }, [geometryLibrary, clinicData, radius, selectedAddress]);

    useEffect(() => {
        setLoading(true);
        getClinicData();
    }, [service]);

    return (
        <>
            <div className={`clinic-finder clinic-finder--layout-${config.mapLayout}`}>

                <div className="clinic-finder__header">

                    <h3 className="clinic-finder__title">{config.title ? config.title : 'Your nearest CityDoc clinic'}</h3>

                    {config.intro && (
                        <p className={`clinic-finder__intro ${config.service ? 'clinic-finder__intro--gap' : ''}`}>{config.intro}</p>
                    )}

                    {!config.service || config.service === 'clinics' && (
                        <ServiceFilter services={servicesData} selectedService={service} onServiceChange={onServiceChange} />
                    )}

                    <SearchField
                        onSelectAddress={onSelectAddress}
                        onRadiusChange={onRadiusChange}
                        defaultAddressValue={selectedAddress}
                        defaultRadiusValue={radius}
                    />

                </div>

                <div className="clinic-finder__content">

                    {filteredResults && (
                        <ClinicResults selectedAddress={selectedAddress} clinicData={filteredResults} loading={loading} />
                    )}

                </div>

            </div>

            {config && (
                <ClinicKey markers={config.markers} margin={true} />
            )}

        </>
    );
};